<template>
  <div id="editar-usuario" dusk="editar-usuario">
    <div class="vx-row">
      <vs-col vs-lg="8" vs-md="8" vs-sm="12" class="vx-col mb-4">
        <vx-card
          ref="perfilVisualizarCard"
          class="h-full"
          title="Dados pessoais"
          subtitle="Abaixo ficam os seus dados pessoais."
          cardBorder
          noShadow
        >
          <div class="vx-row">
            <vs-col vs-lg="4" vs-md="6" vs-sm="12" class="vx-col mb-4">
              <div class="vx-row">
                <vs-col vs-w="12" class="vx-col">
                  <span>Nome:</span>
                </vs-col>
                <vs-col vs-w="12" class="vx-col">
                  <vs-input
                    v-uppercase
                    v-if="usuario_local"
                    readonly
                    class="w-full"
                    name="nome"
                    v-model="usuario_local.nome"
                  />
                </vs-col>
              </div>
            </vs-col>
            <vs-col vs-lg="4" vs-md="4" vs-sm="12" class="vx-col mb-4">
              <div class="vx-row">
                <vs-col vs-w="12" class="vx-col">
                  <span>Telefone:</span>
                </vs-col>
                <vs-col vs-w="12" class="vx-col">
                  <vs-input
                    v-uppercase
                    v-if="usuario_local"
                    readonly
                    class="w-full"
                    name="telefone"
                    :v-model="usuario_local.telefone || 'Não informado'"
                  />
                </vs-col>
              </div>
            </vs-col>
            <vs-col vs-lg="4" vs-md="4" vs-sm="12" class="vx-col mb-4">
              <div class="vx-row">
                <vs-col vs-w="12" class="vx-col">
                  <span>E-mail:</span>
                </vs-col>
                <vs-col vs-w="12" class="vx-col">
                  <vs-input
                    v-uppercase
                    v-if="usuario_local"
                    readonly
                    class="w-full"
                    name="email"
                    v-model="usuario_local.email"
                  />
                </vs-col>
              </div>
            </vs-col>
          </div>
          <div class="vx-row">
            <vs-col vs-lg="4" vs-md="4" vs-sm="12" class="vx-col mb-4">
              <div class="vx-row">
                <vs-col vs-w="12" class="vx-col">
                  <span>Tipo de Usuário:</span>
                </vs-col>
                <vs-col vs-w="12" class="vx-col">
                  <vs-input
                    v-uppercase
                    v-if="usuario_local"
                    readonly
                    class="w-full"
                    name="usuario"
                    v-model="usuario_local.usuarioTipo.nome"
                  />
                </vs-col>
              </div>
            </vs-col>
            <vs-col
              v-if="todasAsAssociacoes && todasAsEntidades && usuario_local.associacao"
              vs-lg="4"
              vs-md="4"
              vs-sm="12"
              class="vx-col mb-4"
            >
              <div class="vx-row">
                <vs-col vs-w="12" class="vx-col">
                  <span>Associação:</span>
                </vs-col>
                <vs-col vs-w="12" class="vx-col">
                  <vs-input
                    v-uppercase
                    v-if="usuario_local"
                    readonly
                    class="w-full"
                    name="usuario"
                    v-model="usuario_local.associacao.nome"
                  />
                </vs-col>
              </div>
            </vs-col>
            <vs-col
              v-if="todasAsEntidades && usuario_local.entidade"
              vs-lg="4"
              vs-md="4"
              vs-sm="12"
              class="vx-col mb-4"
            >
              <div class="vx-row">
                <vs-col vs-w="12" class="vx-col">
                  <span>Entidade:</span>
                </vs-col>
                <vs-col vs-w="12" class="vx-col">
                  <vs-input
                    v-uppercase
                    v-if="usuario_local"
                    readonly
                    class="w-full"
                    name="usuario"
                    v-model="usuario_local.entidade.nome"
                  />
                </vs-col>
              </div>
            </vs-col>
          </div>
        </vx-card>
      </vs-col>
      <vs-col vs-lg="4" vs-md="4" vs-sm="12" class="vx-col mb-4">
        <vx-card
          class="h-full"
          title="Dados do Usuário"
          subtitle="Abaixo ficam os seus dados de usuário, você pode a qualquer momento modificar estes dados."
          cardBorder
          noShadow
        >
          <div class="vx-row">
            <vs-col vs-lg="12" vs-md="12" vs-sm="12" class="vx-col mb-4">
              <div class="vx-row">
                <vs-col vs-w="12" class="vx-col">
                  <span>CPF:</span>
                </vs-col>
                <vs-col vs-w="12" class="vx-col">
                  <cpf-input
                    v-uppercase
                    v-if="usuario_local"
                    readonly
                    class="w-full"
                    name="cpf"
                    v-model="usuario_local.cpf"
                  />
                </vs-col>
              </div>
            </vs-col>
          </div>
        </vx-card>
      </vs-col>
    </div>
  </div>
</template>

<script>
import api from "@services/api-service";
import queryParams from "@services/repository-service";
import CpfInput from "@/components/inputs/CpfInput.vue";

export default {
  name: "editar-dados-pessoais",
  props: ["usuario"],
  components: { CpfInput },
  data() {
    return {
      usuario_local: "",
      usuario_tipo_id: "",
      loading: false
    };
  },
  created() {
    this.loading = true;
    this.show();
  },
  watch: {
    loading(loading) {
      if (!this.$refs.perfilVisualizarCard) return;
      const cards = this.$refs.perfilVisualizarCard;

      if (loading) {
        cards.refreshcard();
      } else {
        cards.removeRefreshAnimation();
      }
    }
  },
  computed: {},
  methods: {
    notify(title, text, color) {
      this.$vs.notify({
        title: title,
        text: text,
        color: color,
        position: "bottom-center"
      });
    },
    getCurrentUser() {
      return new Promise((resolve, reject) => {
        api()
          .get(`auth/meus-dados`, {
            params: queryParams({
              relationships: ["usuarioTipo", "associacao", "entidade"]
            })
          })
          .then(response => {
            // this.usuario_local = response.data.data;
            resolve(response.data);
          })
          .catch(error => reject(error));
      });
    },
    async show() {
      const current = await this.getCurrentUser();
      if (current.status) {
        this.usuario_local = current.data;
        this.loading = false;
      }
    }
  },
  mounted() {}
};
</script>



